import React from 'react';

interface ChartContainerProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  height?: string;
}

const ChartContainer: React.FC<ChartContainerProps> = ({
  title,
  children,
  className = '',
  height = 'h-64'
}) => {
  return (
    <div className={`space-y-4 ${className}`}>
      <h3 className="text-md font-medium text-neutral-900 dark:text-neutral-100">
        {title}
      </h3>
      <div className={`bg-neutral-50 dark:bg-neutral-800 rounded-xl p-4 ${height}`}>
        {children}
      </div>
    </div>
  );
};

export default ChartContainer;
